module.exports = __webpack_public_path__ + "media/images/board-tejas-c78e7930.png";